import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from '../../../shared/common.service';
import { OrganizationEnumModel } from '../../../shared/constant/organization.model';

@Injectable({
    providedIn: 'root',
})
export class AITripDataService {
    private tripData: any;
    constructor(private http: HttpClient, public commonService: CommonService) { }
    setTripData(data: any) {
        this.tripData = data;
    }

    getTripData() {
        return this.tripData;
    }

    clearTripData() {
        this.tripData = null;
    }

    //#region Open AI 
    private apiUrl = 'https://api.openai.com/v1/chat/completions';
    private organizationAttributes = JSON.parse(localStorage.getItem('organizationAttributes'));
    private apiKey = this.organizationAttributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.GPTAPIKey && attr.value == true)?.customValue
        
    generateTripPlan(prompt: string) {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.apiKey}`,
            'Content-Type': 'application/json'
        });

        const body = {
            model: 'gpt-4', // or 'gpt-3.5-turbo' if you're using that
            messages: [
                { role: 'system', content: 'You are a helpful travel assistant.' },
                { role: 'user', content: prompt },
            ],
            temperature: 0.7,
        };

        return this.http.post(this.apiUrl, body, { headers });
    }

    // Add Custom Package Inquiry
    sendAIPlannerInquiry(payload: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'AIPlannerInquiryDetails/AIPlannerInquiry', payload, { headers });
    }
    //#endregion
}
